import { Flex, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const AgeSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeAgeRange } = useNewClientsListContext();
  const { ageRange } = filtersMap.get(id)!;

  const values = useMemo(() => {
    const { from, to } = ageRange;

    return [
      { value: from, label: `от ${from}` },
      { value: to, label: `до ${to}` },
    ].filter(({ value }) => value !== null);
  }, [ageRange]);

  const onDelete = useCallback(
    (value: number | null) => {
      if (value === ageRange.from) {
        onChangeAgeRange({ from: null, to: ageRange.to }, id);
      } else if (value === ageRange.to) {
        onChangeAgeRange({ from: ageRange.from, to: null }, id);
      }
    },
    [ageRange, onChangeAgeRange, id]
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {values.map(({ value, label }) => (
        <Tag
          key={value}
          className={`${PF}__tag`}
          closable
          onClose={() => onDelete(value)}
        >
          {label}
        </Tag>
      ))}
    </Flex>
  );
};
